import { getPrice } from '@fourthwall/utils/dist/common'
import React from 'react'

export type PriceStringProps = {
  value?: number | string
  negative?: boolean
  currency?: string
  minimumFractionDigits?: number
}

export const PriceString = ({
  value,
  negative,
  currency,
  minimumFractionDigits,
}: PriceStringProps) => {
  if (value === undefined) {
    return null
  }

  const settings = JSON.parse(JSON.stringify({ negative, currency, minimumFractionDigits }))

  if (typeof value === 'string') {
    return <>{getPrice(parseFloat(value), settings)}</>
  }

  return <>{getPrice(value, settings)}</>
}
